import * as React from 'react';
import { LoadingButton } from '@mui/lab';

import { useSelectionContext, useSelectionCount } from 'common/contexts/SelectionContext';

interface Props {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  loading?: boolean;
  unarchive?: boolean;
}

export const ArchiveButton: React.FC<Props> = (props) => {
  const { onClick, loading, unarchive } = props;
  const { selection } = useSelectionContext();

  const count = useSelectionCount(selection);
  const archiveText = unarchive ? 'Unarchive' : 'Archive';

  let label = `${archiveText} selected`;
  switch (selection.model) {
    case 'page':
      label = `${archiveText} selected (${count.toLocaleString()})`;
      break;
    case 'filter':
      label = `${archiveText} all (${count.toLocaleString()})`;
      break;
    default:
      break;
  }

  return (
    <LoadingButton
      onClick={onClick}
      loading={loading}
      classes={{
        loadingIndicator: 'text-blue-900',
        text: 'text-dark',
        disabled: 'text-gray-400',
      }}
      style={{ justifyContent: 'flex-start' }}
      fullWidth
      disabled={selection.model === 'none'}
    >
      <h4 className="font-medium truncate">{label}</h4>
    </LoadingButton>
  );
};
ArchiveButton.displayName = 'ContainerActions.ArchiveButton';
